/* EFp2 Shirt Customiser — v2 (2026-09-24)
   由 Hermes Agent 生成。
   ① 產品頁：讀 #sc-data、畫即時預覽、喺 form.product-form 寫入隱藏 line item properties。
   ② 購物車（drawer + /cart 頁）：把每件衫嘅已選選項列返出嚟（Blockshop 本身唔顯示）。
   兩個模組獨立，互不影響；只係新增 DOM，唔會改主題原有行為。 */
(function () {
  'use strict';
  if (window.__efp2SC) return;   // 全域只行一次（section + layout 都可能載入）
  window.__efp2SC = true;

  /* ============================================================
     ① 產品頁定製器
     ============================================================ */
  (function initProduct() {
    var dataEl = document.getElementById('sc-data');
    var root = document.getElementById('sc-root');
    if (!dataEl || !root) return;

    var DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('[SC] data parse error', e); return; }

    var state = {};
    DATA.groups.forEach(function (g) { state[g.k] = g.dflt; });
    var byKey = {};
    DATA.groups.forEach(function (g) { byKey[g.k] = g; });
    var cur = DATA.groups[0].k;
    // 呢啲部件唔會改變衫身圖層，但客人揀嘅時候值得睇大圖細節
    var DETAIL = ['snap', 'open', 'button'];

    function okExpr(e) {
      if (!e) return true;
      var m = /^(\w+)(==|!=)(.+)$/.exec(e);
      if (!m) return true;
      var s = String(state[m[1]]);
      return m[2] === '==' ? s === m[3] : s !== m[3];
    }
    function visible(g) {
      if (!okExpr(g.cond)) return false;
      if (g.hide && okExpr(g.hide)) return false;   // 例：Bust seam 開咗 → 冇 Pocket
      return true;
    }

    function norm() {
      DATA.groups.forEach(function (g) {
        var allowed = g.opts.filter(function (o) { return !o.off && (!o.only || okExpr(o.only)); });
        if (allowed.length && !allowed.some(function (o) { return o.en === state[g.k]; })) state[g.k] = allowed[0].en;
      });
      // 被隱藏嘅部件（例：Bust seam 開咗嘅 Pocket）強制返去第一個可用選項
      DATA.groups.forEach(function (g) {
        if (!visible(g)) {
          var a0 = g.opts.filter(function (o) { return !o.off; })[0];
          if (a0) state[g.k] = a0.en;
        }
      });
    }

    function el(tag, cls) { var d = document.createElement(tag); if (cls) d.className = cls; return d; }

    function renderNav() {
      var nav = document.getElementById('sc-nav');
      nav.innerHTML = '';
      DATA.groups.forEach(function (g) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = g.label;
        if (!visible(g)) b.classList.add('hide');
        if (g.k === cur) b.classList.add('on');
        b.onclick = function () { cur = g.k; renderNav(); renderGrid(); paint(); scScroll(document.querySelector('.sc-main'), 0.75); };
        nav.appendChild(b);
      });
    }

    // 疊住排（手機／窄欄）先需要滾動；桌面左右排唔使
    function stacked() {
      var m = document.querySelector('.sc-main'), a = document.querySelector('.sc-aside');
      if (!m || !a) return false;
      return a.getBoundingClientRect().top >= m.getBoundingClientRect().bottom - 5;
    }
    function scScroll(el, thr) {
      if (!el || !stacked()) return;
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight * (thr || 0.75) || r.bottom < 80) {
        var y = window.pageYOffset + r.top - headerOffset();
        try { window.scrollTo({ top: y, behavior: 'smooth' }); }
        catch (e) { window.scrollTo(0, y); }
      }
    }
    // 主題頂部有固定 header，唔扣返佢會遮住第一行（Ben 捉過）
    function headerOffset() {
      var cands = ['header', '.layout--header', '.layout--header--root', '[class*="header--root"]', '[class*="header--main"]'];
      for (var i = 0; i < cands.length; i++) {
        var h = document.querySelector(cands[i]);
        if (!h) continue;
        var cs = getComputedStyle(h), rc = h.getBoundingClientRect();
        if ((cs.position === 'fixed' || cs.position === 'sticky') && rc.height > 10) return Math.round(rc.height) + 10;
      }
      return 70;
    }

    function renderGrid() {
      var g = byKey[cur];
      document.getElementById('sc-part').textContent = g.part;
      var hints = {
        cuff: 'Shown only when Long sleeve is selected — you picked: ' + state.sleeve,
        pkplace: 'Step 1 — choose pocket placement',
        pkshape: 'Step 2 — choose pocket shape',
        bustdarts: 'When Bust darts is on, a chest pocket is not available.',
        placket: state.collar === 'Camp collar'
          ? 'Camp collar uses a plain placket — only Plain or Plain 2-btn are available.'
          : 'Live preview — the garment changes as you pick.',
        pleat: 'Back pleats are chosen from the icons below.'
      };
      var AUTO_HINT = 'Live preview — the garment changes as you pick.';
      var NO_HINT = { snap: 1, open: 1, button: 1 };     // 呢三組 Ben 指定唔要提示字
      var txt = hints[g.k] || (NO_HINT[g.k] ? '' : AUTO_HINT);
      var hintEl = document.getElementById('sc-hint');
      hintEl.textContent = txt;
      hintEl.style.display = txt ? '' : 'none';   // 冇提示就唔好留空白行
      var grid = document.getElementById('sc-grid');
      grid.innerHTML = '';
      if (g.k === 'pkshape' && state.pkplace === 'No pocket') {
        var p = el('p', 'sc-hint');
        p.textContent = 'No pocket selected, so pocket shape does not apply. Go back to Pocket step 1: Placement.';
        grid.appendChild(p);
        return;
      }
      g.opts.forEach(function (o) {
        if (o.off) return;                       // 未開放嘅選項一律唔顯示（Ben 定）
        if (o.only && !okExpr(o.only)) return;
        var d = el('div', 'sc-card' + (state[g.k] === o.en ? ' on' : ''));
        d.innerHTML = '<img src="' + o.img + '" alt="">' +
          '<div class="en">' + o.en + '</div>';
        d.onclick = function () { state[g.k] = o.en; renderNav(); renderGrid(); paint();
          scScroll(document.querySelector('.sc-stagewrap'), 0.9); };
        grid.appendChild(d);
      });
    }

    function layerList() {
      var out = [];
      var flat = (state.hem === 'Flat');
      out.push(flat ? DATA.bodyFlat : DATA.body);
      if (state.sleeve && state.sleeve !== 'Sleeveless') {
        var sv = byKey.sleeve.opts.filter(function (o) { return o.en === state.sleeve; })[0];
        if (sv && sv.layer) out.push(sv.layer);
      }
      ['collar', 'placket'].forEach(function (k) {
        var o = byKey[k].opts.filter(function (x) { return x.en === state[k]; })[0];
        if (o && o.layer) out.push(o.layer);
      });
      if (state.bustdarts && state.bustdarts !== 'No bust darts') {
        var bs = byKey.bustdarts.opts.filter(function (x) { return x.en === state.bustdarts; })[0];
        if (bs && bs.layer) out.push(bs.layer);
      }
      if (state.pkplace !== 'No pocket') {
        var sh = byKey.pkshape.opts.filter(function (x) { return x.en === state.pkshape; })[0];
        if (sh && sh.layers) {
          var side = state.pkplace === 'Both pockets' ? 'b' : (state.pkplace === 'Single - Left' ? 'l' : 'r');
          if (sh.layers[side]) out.push(sh.layers[side]);
        }
      }
      return out;
    }

    function renderDetail() {
      var box = document.getElementById('sc-detail');
      if (!box) return;
      var g = byKey[cur];
      // 只有「唔會改變衫身圖層」但睇細節有用嘅部件，先喺選項格下面出大圖
      if (DETAIL.indexOf(g.k) < 0) { box.style.display = 'none'; box.innerHTML = ''; return; }
      var o = g.opts.filter(function (x) { return x.en === state[g.k]; })[0];
      if (!o || o.off) { box.style.display = 'none'; box.innerHTML = ''; return; }
      var note = g.k === 'snap' ? 'Hidden snaps are sewn inside — invisible from the outside.'
        : (g.k === 'open' ? 'The opening style changes how the front closes.' : '');
      var pic = o.photo || o.img;
      box.style.display = 'block';
      box.innerHTML = '<img class="' + (o.photo ? 'sc-d-photo' : '') + '" src="' + pic + '" alt="">' +
        '<div class="sc-d-nm">' + o.en + '</div>' + (note ? '<p class="sc-d-note">' + note + '</p>' : '');
    }

    function paint() {
      norm();
      var wrap = document.querySelector('.sc-stagewrap');
      var closeup = document.getElementById('sc-closeup');
      if (wrap) wrap.style.display = 'block';
      if (closeup) closeup.style.display = 'none';
      var stage = document.getElementById('sc-stage');
      var list = layerList();
      while (stage.children.length > list.length) stage.removeChild(stage.lastChild);
      while (stage.children.length < list.length) {
        var c = document.createElement('canvas'); c.width = 342; c.height = 446; stage.appendChild(c);
      }
      list.forEach(function (src, i) {
        var cv = stage.children[i], ctx = cv.getContext('2d');
        var img = new Image();
        img.onload = function () { ctx.clearRect(0, 0, 342, 446); ctx.drawImage(img, 0, 0, 342, 446); };
        img.onerror = function () { console.warn('[SC] layer load failed', src); };
        img.src = src;
      });
      var sum = document.getElementById('sc-sum');
      sum.innerHTML = DATA.groups.filter(visible).map(function (gg) {
        var o = gg.opts.filter(function (x) { return x.en === state[gg.k]; })[0];
        return '<div><span class="k">' + gg.part + '</span><span class="v">' + (o ? o.en : '—') + '</span></div>';
      }).join('');
      renderDetail();
      writeProps();
    }

    /* ---- 寫入 line item properties（Shopify 原生，落單後改唔到）---- */
    var propBox = null;
    function ensurePropBox() {
      var form = document.querySelector('form.product-form') || document.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      var box = form.querySelector('[data-sc-props]');
      if (!box) {
        box = document.createElement('div');
        box.setAttribute('data-sc-props', '');
        box.style.display = 'none';
        form.appendChild(box);
      }
      propBox = box;
      return box;
    }
    function writeProps() {
      var box = ensurePropBox();
      if (!box) { console.warn('[SC] product form not found — properties not attached'); return; }
      box.innerHTML = '';
      var codes = [];
      DATA.groups.forEach(function (g) {
        if (!visible(g)) return;
        var o = g.opts.filter(function (x) { return x.en === state[g.k]; })[0];
        if (!o) return;
        var i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'properties[' + (DATA.prop[g.k] || g.part) + ']';
        i.value = o.en;                       // 客人只會見到英文名
        box.appendChild(i);
        codes.push(o.c);                      // 工廠代號收埋喺 _codes（前台唔顯示、admin 見到）
      });
      var c = document.createElement('input');
      c.type = 'hidden';
      c.name = 'properties[_codes]';
      c.value = codes.join(',');
      box.appendChild(c);
      var f = document.createElement('input');
      f.type = 'hidden';
      f.name = 'properties[_customiser]';
      f.value = 'v1';
      box.appendChild(f);
      /* ③ 尺寸表：把量度數字寫入 line item properties（inch 就 inch、cm 就 cm，唔換算） */
      if (window.SCSize) {
        window.SCSize.props().forEach(function (p) {
          var e = document.createElement('input');
          e.type = 'hidden';
          e.name = 'properties[' + p.name + ']';
          e.value = p.value;
          box.appendChild(e);
        });
      }
    }

    function init() {
      renderNav(); renderGrid(); paint();
      window.SC = { state: state, groups: DATA.groups, byKey: byKey, sizeReady: false, measureLater: false,
                    guide: DATA.guide || {},
                    charts: DATA.charts || [],
                    saved: DATA.saved || null,
                    savedAt: DATA.savedAt || '',
                    openSize: function () { if (window.SCSize) window.SCSize.open('link'); } };
      // 客人可以喺定製器度自己撳入去填尺寸
      var sum = document.getElementById('sc-sum');
      if (sum && !document.getElementById('sc-size-open')) {
        var b = document.createElement('button');
        b.id = 'sc-size-open'; b.type = 'button'; b.className = 'sc-size-open';
        b.textContent = 'Fill in your shirt measurements';
        b.addEventListener('click', function () { window.SCSize.open('link'); });
        sum.parentNode.insertBefore(b, sum.nextSibling);
      }
      var form = document.querySelector('form.product-form') || document.querySelector('form[action*="/cart/add"]');
      if (form) {
        var allow = false, lastBtn = null;
        function submitNow() {
          allow = true;
          try { if (form.requestSubmit) form.requestSubmit(lastBtn || undefined); else form.submit(); }
          catch (e) { try { form.submit(); } catch (e2) {} }
          setTimeout(function () { allow = false; }, 1500);
        }
        function gate(e) {
          if (allow || !window.SCSize || window.SCSize.ready()) return;   // 已填／揀咗「遲啲填」→ 放行
          e.preventDefault();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          window.SC.__afterSize = submitNow;      // 填完之後真正入車
          window.SCSize.open('add-to-bag');
        }
        form.addEventListener('click', function (e) {
          var t = e.target;
          if (t && t.closest && t.closest('[type="submit"], .product-form__buttons button, button[name="add"]')) {
            lastBtn = t.closest('[type="submit"], .product-form__buttons button, button[name="add"]');
            writeProps(); gate(e);
          }
        }, true);
        form.addEventListener('submit', function (e) { writeProps(); gate(e); }, true);
      }
      console.log('[SC] customiser ready — groups:', DATA.groups.length);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  /* ============================================================
     ② 購物車顯示已選選項（Blockshop 唔會顯示 line item properties）
     ============================================================ */
  (function initCartDisplay() {
    var STYLE_ID = 'sc-cart-style';
    var CSS = '' +
      '.sc-cart-props{margin:6px 0 2px;display:flex;flex-direction:column;gap:2px;}' +
      '.sc-cart-prop{display:flex;gap:6px;font-size:12px;line-height:1.35;opacity:.85;}' +
      '.sc-cart-prop-k{min-width:104px;flex:0 0 auto;text-transform:uppercase;letter-spacing:.04em;opacity:.75;}' +
      '.sc-cart-prop-v{flex:1 1 auto;}';

    function injectStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var s = document.createElement('style');
      s.id = STYLE_ID; s.textContent = CSS;
      (document.head || document.documentElement).appendChild(s);
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
      });
    }
    function run() {
      var nodes = document.querySelectorAll('.cart--item');
      if (!nodes.length) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) return;
          var byLine = {}, byVariant = {};
          cart.items.forEach(function (it, i) {
            byLine[i + 1] = it;
            (byVariant[it.variant_id] = byVariant[it.variant_id] || []).push(it);
          });
          var touched = 0;
          Array.prototype.forEach.call(nodes, function (node) {
            var line = parseInt(node.getAttribute('data-line-num'), 10);
            var vid = parseInt(node.getAttribute('data-variant-id'), 10);
            var item = byLine[line];
            if (!item && byVariant[vid] && byVariant[vid].length === 1) item = byVariant[vid][0];
            if (!item || !item.properties) return;
            var keys = Object.keys(item.properties).filter(function (k) {
              return k.charAt(0) !== '_' && item.properties[k];
            });
            var host = node.querySelector('.cart--item--info') || node.querySelector('.cart--item-details') || node;
            var existing = host.querySelector('.sc-cart-props');
            if (!keys.length) { if (existing) existing.remove(); return; }
            var html = keys.map(function (k) {
              return '<div class="sc-cart-prop"><span class="sc-cart-prop-k">' + esc(k) +
                '</span><span class="sc-cart-prop-v">' + esc(item.properties[k]) + '</span></div>';
            }).join('');
            if (existing) {
              if (existing.getAttribute('data-sig') !== html) { existing.innerHTML = html; existing.setAttribute('data-sig', html); }
              return;
            }
            var wrap = document.createElement('div');
            wrap.className = 'sc-cart-props';
            wrap.setAttribute('data-sig', html);
            wrap.innerHTML = html;
            host.appendChild(wrap);
            touched++;
          });
          if (touched) console.log('[SC] cart properties rendered on', touched, 'line(s)');
        })
        .catch(function () { /* 靜靜失敗，唔影響購物車 */ });
    }

    function boot() {
      try { injectStyle(); } catch (e) {}
      run();
      var t = null;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () {
          obs.disconnect();
          try { run(); } finally {
            obs.observe(document.body, { childList: true, subtree: true });
          }
        }, 250);
      });
      obs.observe(document.body, { childList: true, subtree: true });
      // 開 drawer / 去 cart 頁時再確認一次
      document.addEventListener('click', function (e) {
        var t2 = e.target;
        if (t2 && t2.closest && t2.closest('[data-drawer-trigger], .cart--toggle, a[href*="/cart"], [data-cart-toggle]')) {
          setTimeout(run, 600); setTimeout(run, 1600);
        }
      }, true);
      window.addEventListener('pageshow', function () { setTimeout(run, 300); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  /* ============================================================
     ③ 尺寸表：客人填「完成恤衫平放」尺寸（唔量身體）
        流程：撳 ADD TO BAG → 未填就彈呢個表 → 填完先真正入車
     ============================================================ */
  window.SCSize = (function () {
    var KEY = 'sc_measure_v1';
    var UNIT_KEY = 'sc_measure_unit';
    var CLEAR_KEY = 'sc_measure_cleared_v1';   // 客人撳過 Clear：呢部機唔再由會員檔案自動填（見 render／load）
    var FIELDS = [
      { k: 'collar',   en: 'Collar width',          note: 'From button centre to buttonhole edge', req: true },
      { k: 'chest',    en: 'Chest (half)',          note: 'Straight across, armpit to armpit, laid flat', req: true },
      { k: 'waist',    en: 'Waist (half)',          note: 'Narrowest point, laid flat', req: true },
      { k: 'hem',      en: 'Bottom hem (half)',     note: 'Straight across the bottom edge', req: true },
      { k: 'shoulder', en: 'Shoulder width',        note: 'Top of the shirt, shoulder seam to shoulder seam', req: true },
      { k: 'length',   en: 'Shirt length',          note: 'From back neck seam to bottom edge', req: true },
      { k: 'slong',    en: 'Sleeve length — long',  note: 'From shoulder seam to cuff edge', req: 'Long' },
      { k: 'sshort',   en: 'Sleeve length — short', note: 'From shoulder seam to sleeve edge', req: 'Short' },
      { k: 'arm',      en: 'Sleeve width (half)',   note: '2" below the armhole', req: true },
      { k: 'cuff',     en: 'Cuff width (half)',     note: 'Straight across the cuff opening', req: true }
    ];
    // 守門員：呢 5 個部位要半圍。客人填咗個「睇落係全圍」嘅數（超出合理半圍上限）→ 提示一撳 ÷2（唔會自動改）
    var HALFMAX = { chest: { in: 30, cm: 76 }, waist: { in: 30, cm: 76 }, hem: { in: 32, cm: 81 },
                    arm: { in: 13, cm: 33 }, cuff: { in: 9, cm: 23 } };
    var CSS = '' +
      '.scm,.scm *,.scg,.scg *{text-transform:none !important;letter-spacing:normal !important;}' +
      '.scm-bg{position:fixed;inset:0;z-index:99998;background:rgba(0,0,0,.55);display:none;' +
        'align-items:flex-start;justify-content:center;overflow:auto;-webkit-overflow-scrolling:touch;}' +
      '.scm-bg.on{display:flex;}' +
      '.scm{background:#fff;color:#111;max-width:760px;width:calc(100% - 24px);margin:24px auto;border-radius:8px;' +
        'box-shadow:0 12px 40px rgba(0,0,0,.3);font-size:14px;line-height:1.4;}' +
      '.scm-hd{padding:16px 18px 12px;border-bottom:1px solid #eee;position:relative;}' +
      '.scm-hd h3{margin:0 0 6px;font-size:17px;font-weight:700;}' +
      '.scm-hd p{margin:0;font-size:12.5px;opacity:.8;}' +
      '.scm-x{position:absolute;top:10px;right:12px;background:none;border:0;font-size:22px;line-height:1;cursor:pointer;' +
        'color:#111;padding:4px 6px;}' +
      '.scm-u{display:flex;align-items:center;gap:8px;padding:12px 18px 0;font-size:13px;}' +
      '.scm-u span{margin-right:2px;opacity:.75;}' +
      '.scm-u button{border:1px solid #ccc;background:#fff;color:#111;padding:5px 14px;border-radius:999px;cursor:pointer;font-size:13px;}' +
      '.scm-u button.on{background:#111 !important;color:#fff !important;border-color:#111 !important;font-weight:700;}' +
      '.scm-g{display:grid;grid-template-columns:1fr 1fr;gap:10px 16px;padding:14px 18px 4px;}' +
      '.scm-row{display:flex;flex-direction:column;gap:3px;}' +
      '.scm-row label{font-weight:600;font-size:13px;}' +
      '.scm-row small{opacity:.65;font-size:11.5px;line-height:1.25;}' +
      '.scm-row input{border:1px solid #ccc;border-radius:4px;padding:8px 10px;font-size:15px;width:100%;box-sizing:border-box;color:#111;background:#fff;}' +
      '.scm-row.bad input{border-color:#c00;background:#fff6f6;}' +
      '.scm-row.bad::after{content:"Please enter a number";color:#c00;font-size:11px;}' +
      '.scm-hint2{margin-top:6px;font-size:12px;line-height:1.35;color:#7a5200;background:#fff8e6;' +
        'border:1px solid #f0d9a0;border-radius:4px;padding:6px 8px;display:flex;gap:8px;align-items:center;flex-wrap:wrap;}' +
      '.scm-hint2 button{border:1px solid #7a5200;background:#fff;color:#7a5200;border-radius:999px;' +
        'padding:4px 10px;font-size:12px;cursor:pointer;font-weight:700;}' +
      '.scm-back{margin-top:8px;font-size:12.5px;line-height:1.4;background:#eef6ee;border:1px solid #cfe3cf;' +
        'border-radius:6px;padding:8px 10px;color:#1d3d1d;}' +
      '.scm-clear{margin-left:4px;border:1px solid #1d3d1d;background:#fff;color:#1d3d1d;border-radius:999px;' +
        'padding:3px 9px;font-size:11.5px;cursor:pointer;font-weight:600;}' +
      '.scm-ft{padding:14px 18px 18px;display:flex;flex-wrap:wrap;gap:10px;align-items:center;}' +
      '.scm-ft button{border-radius:999px;padding:12px 22px;font-size:14px;cursor:pointer;border:1px solid #111;}' +
      '.scm-go{background:#111 !important;color:#fff !important;font-weight:700;}' +
      '.scm-later{background:#fff !important;color:#111 !important;}' +
      '.scm-err{width:100%;color:#c00;font-size:12.5px;}' +
      '.scm-tip{padding:0 18px 16px;font-size:12px;opacity:.7;}' +
      '.scm-acct{padding:12px 18px 0;font-size:12.5px;line-height:1.45;opacity:.85;}' +
      '.scm-acct a{color:#111;text-decoration:underline;font-weight:600;}' +
      '.scm-hdrow{display:flex;align-items:center;gap:10px;flex-wrap:wrap;}' +
      '.scm-guide-btn{background:#fff;color:#111;border:1px solid #111;border-radius:999px;padding:6px 14px;' +
        'font-size:12.5px;font-weight:600;cursor:pointer;}' +
      '.scm-help{background:none;border:0;padding:0;color:#111;text-decoration:underline;font-size:11.5px;' +
        'cursor:pointer;text-align:left;opacity:.7;}' +
      '.scm-guide-btn{border:1px solid #111;background:#fff;color:#111;border-radius:999px;padding:7px 14px;' +
        'font-size:12.5px;cursor:pointer;font-weight:600;}' +
      '.scm-guide-btn:hover{background:#f2f2f2 !important;color:#111 !important;}' +
      '.scm-later:hover{background:#f2f2f2 !important;color:#111 !important;}' +
      '.scm-help:hover{opacity:1;}' +
      '.scg-nav button:hover{background:#f2f2f2 !important;color:#111 !important;}' +
      '.scg-bg{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.6);display:none;' +
        'align-items:center;justify-content:center;padding:14px;}' +
      '.scg-bg.on{display:flex;}' +
      '.scg{background:#fff;color:#111;max-width:880px;width:100%;max-height:92vh;overflow:auto;' +
        'border-radius:8px;padding:16px 18px 14px;box-sizing:border-box;}' +
      '.scg-top{display:flex;align-items:center;gap:12px;margin-bottom:10px;}' +
      '.scg-top h4{margin:0;font-size:16px;font-weight:700;}' +
      '.scg-top .scg-i{margin-left:auto;font-size:12px;opacity:.6;}' +
      '.scg-x{background:none;border:0;font-size:22px;line-height:1;cursor:pointer;color:#111;padding:0 4px;}' +
      '.scg img{width:100%;height:auto;display:block;border:1px solid #eee;border-radius:4px;background:#fff;}' +
      '.scg p{margin:10px 0 0;font-size:12.5px;opacity:.8;}' +
      '.scg-cap{margin:10px 0 0;font-size:12.5px;opacity:.8;}' +
      '.scg-txt{font-size:13.5px;line-height:1.55;color:#111;}' +
      '.scg-txt b{font-weight:700;}' +
      '.scg-txt ul{margin:0 0 12px;padding-left:18px;}' +
      '.scg-txt li{margin:0 0 4px;}' +
      '.scg-lead{margin:0 0 12px;font-size:13.5px;opacity:.85;}' +
      '.scg-cards{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:0 0 14px;}' +
      '.scg-card{border:1px solid #e3e3e3;border-radius:8px;padding:12px 14px;background:#fafafa;}' +
      '.scg-card h5{margin:0 0 6px;font-size:14px;font-weight:700;}' +
      '.scg-card p{margin:0 0 6px;font-size:13px;line-height:1.45;}' +
      '.scg-card ul{margin:0;padding-left:16px;font-size:12.5px;line-height:1.45;}' +
      '.scg-card li{margin:0 0 4px;}' +
      '.scg-note{border:1px solid #111;border-radius:8px;padding:12px 14px;margin:0 0 14px;}' +
      '.scg-note p{margin:6px 0 0;font-size:13px;line-height:1.5;}' +
      '.scg-eg{font-weight:700;}' +
      '.scg-acc{border-top:1px solid #eee;padding:10px 0;}' +
      '.scg-acc summary{cursor:pointer;font-weight:700;font-size:13.5px;}' +
      '.scg-acc p{margin:8px 0 0;font-size:13px;line-height:1.5;}' +
      '.scg-fig{margin:0 0 18px;}' +
      '.scg-fig img{width:100%;height:auto;display:block;border:1px solid #eee;border-radius:4px;background:#fff;}' +
      '.scg-fig figcaption{margin:6px 0 0;font-size:12.5px;line-height:1.5;opacity:.85;}' +
      '.scg-list{border:1px solid #111;border-radius:8px;padding:12px 14px;margin:0 0 16px;}' +
      '.scg-list ul{margin:0;padding-left:16px;font-size:13px;line-height:1.5;}' +
      '.scg-list li{margin:0 0 4px;}' +
      '.scg-list li:last-child{margin:0;}' +
      '@media(max-width:640px){.scg-cards{grid-template-columns:1fr;}}' +
      '.scg-nav{display:flex;gap:10px;justify-content:space-between;margin-top:12px;}' +
      '.scg-nav button{border:1px solid #111;background:#fff;color:#111;border-radius:999px;padding:9px 18px;' +
        'font-size:13px;cursor:pointer;}' +
      '.scg-nav button:disabled{opacity:.35;cursor:default;}' +
      '@media(max-width:640px){.scm-g{grid-template-columns:1fr;}.scm{margin:8px auto;width:calc(100% - 16px);}' +
        '.scm-ft button{flex:1 1 100%;}.scg{padding:12px;}.scg-top h4{font-size:15px;}}';

    var unit = 'in', vals = {}, done = false, el = null, gid = null, gi = 0, stdOk = false, fromAccount = false, fromLink = false;

    function inject() {
      if (document.getElementById('sc-size-css')) return;
      var s = document.createElement('style');
      s.id = 'sc-size-css'; s.textContent = CSS;
      (document.head || document.documentElement).appendChild(s);
    }
    function countryUnit() {
      var S = window.Shopify || {};
      var c = S.country || (S.locale || '').split('-')[1] || (navigator.language || '').split('-')[1] || '';
      c = String(c).toUpperCase();
      return ['US', 'CA', 'GB', 'LR', 'MM'].indexOf(c) >= 0 ? 'in' : 'cm';
    }
    function sleeveNow() {
      var st = (window.SC && window.SC.state) || {};
      return st.sleeve || 'Long';
    }
    function needed(f) { if (isStandard()) return false; return f.req === true || String(f.req) === sleeveNow(); }
    /* 標準尺碼路線：客人喺 Size 揀咗標準碼（唔係 Made to measure）→ 只改個別部位 */
    function sizeOption() {
      var f = document.querySelector('form.product-form') || document.querySelector('form[action*="/cart/add"]');
      if (!f) return '';
      var els = f.querySelectorAll('input[name$="-size"], select[name$="-size"], [name="options[Size]"]');
      for (var i = 0; i < els.length; i++) {
        if (els[i].tagName === 'SELECT' || els[i].checked) return String(els[i].value || '');
      }
      return els.length ? String(els[0].value || '') : '';
    }
    function isStandard() {
      var v = sizeOption();
      if (!v) return false;
      return !/made\s*to\s*measure|custom|bespoke|tailor/i.test(v);
    }
    function savedData() {
      var sv = (window.SC && window.SC.saved) || null;
      if (typeof sv === 'string') { try { sv = JSON.parse(sv); } catch (e) { sv = null; } }
      return (sv && typeof sv === 'object' && sv.fields) ? sv : null;
    }
    /* 客人撳過「Clear and start fresh」→ 呢部機唔再由會員檔案自動填（否則 reload 又返晒，
       客人會覺得 Clear 冇用）。會員檔案本身要等佢落新單先被覆寫——storefront 刪唔到。 */
    function clearedLocal() {
      try { return !!localStorage.getItem(CLEAR_KEY); } catch (e) { return false; }
    }
    /* 做法 B（2026-09-30）：客人喺自己帳戶頁撳「Use these measurements」帶過來嘅尺寸。
       ⛔ 新制客戶帳戶住喺 shopify.com（另一網域）→ 前台 Liquid 永遠拎唔到 customer，
       所以改用 URL 錨點（#scm=<base64url JSON>）傳：唔經 server、唔入 log、換機都 work。 */
    function linkData() {
      var h = '';
      try { h = String(location.hash || ''); } catch (e) { return null; }
      var m = /(?:^#|&)scm=([^&]+)/.exec(h);
      if (!m) return null;
      var raw = m[1];
      try { raw = decodeURIComponent(raw); } catch (e) {}
      /* 格式①（extension 用，短又讀得明）：in|collar=20|chest=50|… */
      if (raw.indexOf('|') >= 0) {
        var o = { v: 1, unit: '', fields: {} };
        raw.split('|').forEach(function (p, i) {
          var kv = p.split('=');
          if (kv.length === 2) { if (kv[0] && kv[1]) o.fields[kv[0]] = kv[1]; }
          else if (i === 0 && (p === 'in' || p === 'cm')) { o.unit = p; }
        });
        if (Object.keys(o.fields).length) return o;
      }
      /* 格式②（備用）：base64url JSON */
      try {
        var b64 = raw.replace(/-/g, '+').replace(/_/g, '/');
        while (b64.length % 4) { b64 += '='; }
        var j = JSON.parse(decodeURIComponent(escape(window.atob(b64))));
        if (j && j.fields && typeof j.fields === 'object') return j;
      } catch (e) {}
      return null;
    }
    function stripHash() {
      try { if (location.hash) history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    }
    function load() {
      var local = false;
      try {
        var raw = localStorage.getItem(KEY);
        if (raw) { var o = JSON.parse(raw); if (o && o.vals && Object.keys(o.vals).length) { vals = o.vals; done = !!o.done; local = true; } }
        var u = localStorage.getItem(UNIT_KEY); if (u) unit = u;
      } catch (e) {}
      if (!unit) unit = countryUnit();
      /* 做法 B：由帳戶頁帶過來（客人啱啱撳掣 → 優先，覆蓋本地紀錄） */
      var lk = linkData();
      if (lk) {
        var lo = {};
        FIELDS.forEach(function (f) { if (lk.fields[f.k] != null && lk.fields[f.k] !== '') lo[f.k] = String(lk.fields[f.k]); });
        if (Object.keys(lo).length) {
          vals = lo;
          if (lk.unit === 'in' || lk.unit === 'cm') unit = lk.unit;
          if (lo.collar && lo.chest) { done = true; window.SC.sizeReady = true; }
          fromAccount = true; fromLink = true;
          try { localStorage.removeItem(CLEAR_KEY); } catch (e) {}
          save();
          console.log('[SC] measurements loaded from account link:', Object.keys(lo).join(','));
        }
        stripHash();
      }
      /* 做法 A：登入客人嘅會員檔案（上次訂單嘅尺寸）— 本地冇紀錄時優先採用 */
      var sv = savedData();
      if (!local && !fromLink && sv && !clearedLocal()) {
        var ok = {};
        FIELDS.forEach(function (f) { if (sv.fields[f.k] != null && sv.fields[f.k] !== '') ok[f.k] = String(sv.fields[f.k]); });
        if (Object.keys(ok).length) {
          vals = ok;
          if (sv.unit === 'in' || sv.unit === 'cm') unit = sv.unit;
          if (sv.mode === 'custom' && ok.collar && ok.chest) { done = true; window.SC.sizeReady = true; }
          fromAccount = true;
          console.log('[SC] measurements loaded from customer account:', Object.keys(ok).join(','), '| order', sv.order || '?');
        }
      }
    }
    function save() {
      try {
        localStorage.setItem(KEY, JSON.stringify({ vals: vals, done: done }));
        localStorage.setItem(UNIT_KEY, unit);
      } catch (e) {}
    }
    /* ⛔ 提示格唔可以每次 blur 都重砌 innerHTML：重砌會換走「Use」嗰粒掣，
       mousedown 命中舊 node、mouseup 命中新 node → 瀏覽器完全唔發 click，
       客人「打完數字即刻撳」第一下冇反應（實測 2026-09-30，真人時序按住 140ms 重現）。
       內容無變就唔重砌。 */
    var hintHtml = {};
    function hideHint(k, box) {
      if (box.style.display !== 'none') box.style.display = 'none';
      if (hintHtml[k]) { box.innerHTML = ''; hintHtml[k] = ''; }
    }
    function guard(k) {
      if (!el) return;
      var row = el.querySelector('.scm-row[data-k="' + k + '"]'); if (!row) return;
      var box = row.querySelector('.scm-hint2'); if (!box) return;
      var f = HALFMAX[k], inp = row.querySelector('input');
      var v = parseFloat(String((inp && inp.value) || '').replace(',', '.'));
      if (!f || !isFinite(v) || v <= 0) { hideHint(k, box); return; }
      var max = (unit === 'cm') ? f.cm : f.in;
      if (v <= max) { hideHint(k, box); return; }
      var half = Math.round((v / 2) * 100) / 100;
      var html = '<span>' + v + ' ' + unit + ' looks like a <b>full</b> measurement — that is <b>' + half + ' ' + unit + '</b> flat.</span>' +
                 '<button type="button" class="scm-usehalf" data-k="' + k + '" data-v="' + half + '">Use ' + half + '</button>';
      if (hintHtml[k] !== html) { box.innerHTML = html; hintHtml[k] = html; }
      box.style.display = '';
      console.log('[SC] half-guard fired', k, v, '→', half);
    }
    function build() {
      if (el) return el;
      var bg = document.createElement('div');
      bg.className = 'scm-bg';
      bg.innerHTML =
        '<div class="scm" role="dialog" aria-modal="true">' +
          '<div class="scm-hd"><button class="scm-x" type="button" aria-label="Close">&times;</button>' +
            '<div class="scm-hdrow"><h3>Your finished shirt measurements</h3>' +
              '<button type="button" class="scm-guide-btn">Size guide — how to order &amp; measure</button></div>' +
            '<p>Measure a shirt you already own and like — <b>lay it flat</b> and take the half measurement where shown. ' +
            'We cut the shirt to these numbers, so please measure a <b>finished shirt</b>, not your body.</p>' +
            '<div class="scm-back" style="display:none"></div></div>' +
          '<div class="scm-acct">Already saved your measurements in your account? ' +
            '<a href="/account">Open your account</a> — then tap &ldquo;Use these measurements on my next shirt&rdquo; ' +
            'and your numbers come back with you.</div>' +
          '<div class="scm-u"><span>Unit:</span>' +
            '<button type="button" data-u="in">inch</button><button type="button" data-u="cm">cm</button></div>' +
          '<div class="scm-g"></div>' +
          '<div class="scm-tip">Tip: keep the shirt buttoned and smooth on a table. Tolerance ±3–5% is normal for tailoring.</div>' +
          '<div class="scm-ft"><button type="button" class="scm-go">Add to bag</button>' +
            '<button type="button" class="scm-later">Fill in later</button>' +
            '<div class="scm-err" style="display:none"></div></div>' +
        '</div>';
      document.body.appendChild(bg);
      var grid = bg.querySelector('.scm-g');
      FIELDS.forEach(function (f) {
        var r = document.createElement('div');
        r.className = 'scm-row'; r.setAttribute('data-k', f.k);
        r.innerHTML = '<label for="scm-' + f.k + '">' + f.en + ' <span class="scm-u2"></span></label>' +
                      '<small>' + f.note + '</small>' +
                      '<button type="button" class="scm-help">How to measure</button>' +
                      '<input id="scm-' + f.k + '" inputmode="decimal" autocomplete="off">' +
                      '<div class="scm-hint2" style="display:none"></div>';
        grid.appendChild(r);
        var inp = r.querySelector('input');
        inp.addEventListener('input', function () { guard(f.k); });
        inp.addEventListener('blur', function () { guard(f.k); });
      });
      var g = document.createElement('div');
      g.className = 'scg-bg';
      g.innerHTML = '<div class="scg"><div class="scg-top"><h4></h4><span class="scg-i"></span>' +
        '<button type="button" class="scg-x" aria-label="Close">&times;</button></div>' +
        '<img alt=""><div class="scg-txt" style="display:none"></div><p class="scg-cap"></p>' +
        '<div class="scg-nav"><button type="button" class="scg-prev">Previous</button>' +
        '<button type="button" class="scg-next">Next</button></div></div>';
      document.body.appendChild(g);
      gid = g;
      g.addEventListener('click', function (e) {
        var t = e.target;
        if (t === g || (t.closest && t.closest('.scg-x'))) { g.classList.remove('on'); return; }
        if (!t.closest) return;
        if (t.closest('.scg-prev')) { showGuide(gi - 1); return; }
        if (t.closest('.scg-next')) { showGuide(gi + 1); return; }
      });
      bg.addEventListener('click', function (e) {
        var t = e.target;
        if (t === bg) { close(); return; }
        if (!t.closest) return;
        var u = t.closest('[data-u]');
        if (u) { unit = u.getAttribute('data-u'); save(); render(); return; }
        var uh = t.closest('.scm-usehalf');
        if (uh) {
          var kk = uh.getAttribute('data-k'), rw = el.querySelector('.scm-row[data-k="' + kk + '"]');
          var i2 = rw.querySelector('input');
          i2.value = uh.getAttribute('data-v'); vals[kk] = i2.value; save(); guard(kk);
          return;
        }
        if (t.closest('.scm-help')) { openGuide(t.closest('.scm-row').getAttribute('data-k')); return; }
        if (t.closest('.scm-clear')) {
          vals = {}; done = false; fromAccount = false; fromLink = false; window.SC.measureLater = false;
          try { localStorage.removeItem(KEY); } catch (e) {}
          try { localStorage.setItem(CLEAR_KEY, '1'); } catch (e) {}
          FIELDS.forEach(function (f) { var i3 = el.querySelector('#scm-' + f.k); if (i3) i3.value = ''; guard(f.k); });
          render();
          console.log('[SC] measurements cleared by customer');
          return;
        }
        if (t.closest('.scm-chart-btn')) { openGuide('chart'); return; }
        if (t.closest('.scm-guide-btn')) { openGuide('intro'); return; }
        if (t.closest('.scm-x')) { close(); return; }
        if (t.closest('.scm-go')) { commit(false); return; }
        if (t.closest('.scm-later')) { commit(true); return; }
      });
      el = bg;
      return el;
    }
    function render() {
      Array.prototype.forEach.call(el.querySelectorAll('[data-u]'), function (b) {
        b.classList.toggle('on', b.getAttribute('data-u') === unit);
      });
      var std = isStandard(), sz = sizeOption();
      var h3 = el.querySelector('.scm-hdrow h3'), intro = el.querySelector('.scm-hd p');
      if (std) {
        h3.textContent = 'Your size: ' + sz + ' — adjust any part';
        intro.innerHTML = 'Your shirt is made to our size chart for <b>' + sz + '</b>. Fill in only the parts you want changed — blanks follow the chart.<br>' +
          'Chart numbers are <b>full</b>; the boxes want the <b>half</b> (measure flat). See <b>Size guide</b> for details.';
        el.querySelector('.scm-later').style.display = 'none';
      } else {
        h3.textContent = 'Your finished shirt measurements';
        intro.innerHTML = 'Measure your shirt flat — <b>the tape gives the half</b>. (Our standard size chart lists full numbers, so halve those.) ' +
          'See <b>Size guide</b> for details.';
        el.querySelector('.scm-later').style.display = '';
      }
      FIELDS.forEach(function (f) { guard(f.k); });
      var bk = el.querySelector('.scm-back'), sv2 = savedData();
      if (bk) {
        if (fromLink) {
          bk.innerHTML = '<b>Welcome back.</b> These are the measurements saved in your account — change anything you like. ' +
            '<button type="button" class="scm-clear">Clear and start fresh</button>';
          bk.style.display = '';
        } else if (sv2 && !clearedLocal()) {
          var when = (window.SC && window.SC.savedAt) ? ' (' + window.SC.savedAt + ')' : '';
          bk.innerHTML = '<b>Welcome back.</b> These are your measurements from your last order' + when +
            '. Change anything you like — your shirt is made to exactly what you see here. ' +
            '<button type="button" class="scm-clear">Clear and start fresh</button>';
          bk.style.display = '';
        } else { bk.style.display = 'none'; bk.innerHTML = ''; }
      }
      var ob = document.getElementById('sc-size-open');
      if (ob) ob.textContent = std ? 'Adjust your size (optional)' : 'Fill in your shirt measurements';
      FIELDS.forEach(function (f) {
        var r = el.querySelector('.scm-row[data-k="' + f.k + '"]');
        var inp = r.querySelector('input');
        if (inp.value === '' && vals[f.k] != null) inp.value = vals[f.k];
        r.querySelector('.scm-u2').textContent = '(' + unit + ')';
        r.style.opacity = needed(f) ? '1' : '.5';
      });
    }
    function collect() {
      var bad = [];
      FIELDS.forEach(function (f) {
        var r = el.querySelector('.scm-row[data-k="' + f.k + '"]');
        var v = (r.querySelector('input').value || '').trim();
        r.classList.remove('bad');
        if (!needed(f)) { if (v) vals[f.k] = v; else delete vals[f.k]; return; }
        if (!/^\d+(\.\d+)?$/.test(v) || parseFloat(v) <= 0) { r.classList.add('bad'); bad.push(f.en); return; }
        vals[f.k] = v;
      });
      return bad;
    }
    function open(why) {
      inject(); build();
      el.classList.add('on'); render();
      var first = el.querySelector('.scm-g input');
      if (first) { try { first.focus(); } catch (e) {} }
      console.log('[SC] size table opened (' + (why || '') + ')');
    }
    function close() { if (el) el.classList.remove('on'); }
    /* ---- Size guide／Size chart（Option 1/2 說明 + 教學圖 + 尺碼表，逐頁揭） ---- */
    var ORDER_HTML =
      '<p class="scg-lead">Both ways cost the same — pick the one that suits you.</p>' +
      '<div class="scg-cards">' +
        '<div class="scg-card"><h5>Option 1 — Standard size</h5>' +
        '<p>Pick a size from <b>000 (XXXS) to 24 (4XL)</b> in the Size box. We make your shirt to our size chart.</p>' +
        '<ul><li><b>Want a change?</b> Fill in only those parts — we use the chart for everything else.</li>' +
        '<li><b>Happy as it is?</b> Leave every box blank.</li></ul></div>' +
        '<div class="scg-card"><h5>Option 2 — Custom size (measure your shirt)</h5>' +
        '<p>Pick <b>Made to measure</b> in the Size box, then fill in all 10 numbers from a shirt you own and like.</p>' +
        '<ul><li>Measure the <b>shirt</b>, not your body.</li></ul></div>' +
      '</div>' +
      '<div class="scg-note"><b>Full or half? Please read this.</b>' +
      '<p><b>Our standard size chart</b> shows <b>full</b> measurements (all the way around the shirt). Lay a shirt flat and measure across it, and you get the <b>half</b> — and every box in the form asks for the half.</p>' +
      '<p class="scg-eg">Example: our chart chest 42 in → enter <b>21</b>.</p></div>' +
      '<details class="scg-acc"><summary>How to measure</summary>' +
      '<p>Lay the shirt flat and buttoned, then measure across the lines shown on the <b>How to measure</b> page. Use the same unit (inch or cm) for every box.</p></details>' +
      '<details class="scg-acc"><summary>Good to know</summary>' +
      '<p>We make every shirt from <b>shirt measurements</b>, not body measurements. Shirts are hand-made, so ±3–5% is normal. Your first order includes one free alteration or remake. Questions? Email info@efp2.com</p></details>';
    function guideMap() { return (window.SC && window.SC.guide) || {}; }
    function pageList() {
      var charts = (window.SC && window.SC.charts) || [];
      var hCharts = '<p class="scg-lead">Find the size closest to a shirt you already own and like. Every number in <b>our standard size chart</b> is <b>full</b> (all the way around the shirt). The form asks for the <b>half</b> — lay the shirt flat and measure across it.</p>' +
        '<div class="scg-list"><ul>' +
        '<li><b>Want a change?</b> Fill in only those parts — we use our standard size chart for everything else.</li>' +
        '<li><b>Happy as it is?</b> Leave every box blank.</li>' +
        '</ul></div>';
      charts.forEach(function (c) {
        hCharts += '<figure class="scg-fig"><img src="' + c.img + '" alt="' + c.en + '" loading="lazy">' +
                   '<figcaption><b>' + c.en + '</b>' + (c.note ? ' — ' + c.note : '') + '</figcaption></figure>';
      });
      var hFields = '<p class="scg-lead">Measure a shirt you already own and like — <b>lay it flat and buttoned</b> — then enter the <b>half</b> number in each box. <b>Our standard size chart</b> lists <b>full</b> numbers: chart chest 41 in means enter <b>20.5</b>.</p>';
      FIELDS.forEach(function (f) {
        hFields += '<figure class="scg-fig" id="scg-f-' + f.k + '"><img src="' + (guideMap()[f.k] || '') + '" alt="' + f.en + '" loading="lazy">' +
                   '<figcaption><b>' + f.en + '</b> — ' + f.note +
                   (f.req === true ? '' : ' (only needed when this sleeve length is chosen)') + '</figcaption></figure>';
      });
      return [
        { en: 'Two ways to order', html: ORDER_HTML },
        { en: 'Option 1 — Standard size', html: hCharts },
        { en: 'How to measure (Option 2)', html: hFields }
      ];
    }
    function showGuide(i) {
      var P = pageList();
      if (!gid || i < 0 || i >= P.length) return;
      gi = i;
      var it = P[i];
      gid.querySelector('h4').textContent = it.en;
      gid.querySelector('.scg-i').textContent = (i + 1) + ' / ' + P.length;
      var img = gid.querySelector('img'), txt = gid.querySelector('.scg-txt'), cap = gid.querySelector('.scg-cap');
      if (it.html) { img.style.display = 'none'; img.removeAttribute('src'); txt.innerHTML = it.html; txt.style.display = ''; }
      else { txt.style.display = 'none'; txt.innerHTML = ''; img.style.display = ''; img.src = it.img; img.alt = it.en; }
      cap.textContent = it.note || '';
      cap.style.display = it.note ? '' : 'none';
      gid.querySelector('.scg-prev').disabled = (i === 0);
      gid.querySelector('.scg-next').disabled = (i === P.length - 1);
    }
    function openGuide(key) {
      build();
      var idx = (key === 'chart') ? 1 : 2;
      gid.classList.add('on');
      showGuide(idx);
      if (key !== 'chart') {
        var t = document.getElementById('scg-f-' + key);
        if (t) { try { t.scrollIntoView({ block: 'center' }); } catch (e) {} }
      }
      console.log('[SC] guide opened —', pageList()[idx].en);
    }
    function commit(later) {
      var err = el.querySelector('.scm-err');
      if (later) {
        vals = {}; done = false;
        window.SC.measureLater = true; window.SC.sizeReady = true;
        el.classList.remove('on');
        if (window.SC.__afterSize) window.SC.__afterSize();
        return;
      }
      var bad = collect();
      if (bad.length) {
        err.style.display = 'block';
        err.textContent = 'Please fill: ' + bad.join(', ');
        var b = el.querySelector('.scm-row.bad input'); if (b) b.focus();
        return;
      }
      err.style.display = 'none';
      if (isStandard()) {                      // 標準尺碼：唔使驗證，記低改咗嘅部位就算
        stdOk = true; el.classList.remove('on');
        try { localStorage.removeItem(CLEAR_KEY); } catch (e) {}
        console.log('[SC] standard size confirmed, adjusted:', JSON.stringify(vals));
        if (window.SC.__afterSize) window.SC.__afterSize();
        return;
      }
      done = true; window.SC.measureLater = false; window.SC.sizeReady = true;
      try { localStorage.removeItem(CLEAR_KEY); } catch (e) {}   // 已交新尺寸 → 唔再壓住會員檔案嗰份
      save(); el.classList.remove('on');
      console.log('[SC] measurements saved', JSON.stringify(vals));
      if (window.SC.__afterSize) window.SC.__afterSize();
    }
    function props() {
      var out = [];
      if (isStandard()) {                      // 標準尺碼：只記錄客人改咗嘅部位
        var adj = [];
        FIELDS.forEach(function (f) {
          if (vals[f.k] != null && vals[f.k] !== '') {
            out.push({ name: f.en, value: vals[f.k] + ' ' + unit + ' (adjusted)' });
            adj.push(f.en);
          }
        });
        out.push({ name: '_size_mode', value: 'standard' });
        out.push({ name: '_size_standard', value: sizeOption() });
        out.push({ name: '_adjust', value: adj.length ? adj.join(', ') : 'none' });
        return out;
      }
      if (!done) { out.push({ name: 'Measurements', value: 'to be filled later' }); return out; }
      FIELDS.forEach(function (f) {
        if (vals[f.k] != null && vals[f.k] !== '') out.push({ name: f.en, value: vals[f.k] + ' ' + unit });
      });
      out.push({ name: '_size_unit', value: unit });
      out.push({ name: '_size_mode', value: 'custom' });
      out.push({ name: '_measure_v', value: 'v1' });
      return out;
    }
    function ready() {
      if (isStandard()) return stdOk;         // 標準尺碼：確認過一次就放行
      return done || window.SC.measureLater === true;
    }
    load();
    return { open: open, close: close, props: props, ready: ready, isDone: function () { return done; },
             unit: function () { return unit; }, values: function () { return vals; } };
  })();
})();
